/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';
import { url } from 'utils/urls';




/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : REVENUE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	revenue: {
		'& .callouts': {
			marginBottom: pxToEm(30),
			'& .callout': {
				opacity: '0',
				transform: 'translateX(-1000%)',
				animationDuration: '.2s',
	            animationFillMode: 'forwards',
				'&:nth-child(1)': { animationName: 'fadeInLeft', animationDelay: '.3s', zIndex: '1' },
				'&:nth-child(2)': { animationName: 'fadeInLeft', animationDelay: '.4s', zIndex: '2' },
				'&:nth-child(3)': { animationName: 'fadeInLeft', animationDelay: '.5s', zIndex: '1' },
				'& .revImg': {
				    backgroundImage: `url(${url.image.app}/graphic-embed-mr-rail.png)`

                }
			}
		}
	}
});